import * as RadixTooltip from "@radix-ui/react-tooltip";
import { PropsWithChildren } from "react";

interface RadixUiTooltipProps extends PropsWithChildren {
  trigger: React.ReactNode;
}

export function Tooltip({ trigger, children }: RadixUiTooltipProps) {
  return (
    <RadixTooltip.Root delayDuration={0}>
      <RadixTooltip.Trigger asChild>{trigger}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className="shadow-default p-3 bg-light border border-[#F1F1F4] rounded-xl bg-white text-gray-700 text-xs font-normal z-[100]"
          sideOffset={5}
        >
          {children}
          <RadixTooltip.Arrow className="fill-white" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
